import { useObservable } from '@logz-pkg/observable';
import { breadcrumbsService } from '../breadcrumbs.state.service';

export const useBreadcrumbs = () => {
  const crumbs = useObservable(breadcrumbsService.crumbs) ?? [];
  const customCrumb = useObservable(breadcrumbsService.customCrumb) ?? null;

  return { crumbs, customCrumb };
};
